import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { asyncValidationMiddlware } from './wizard/asyncValidationMiddleware';
import { reducer as ReduxFormReducer } from 'redux-form';
import {
  combineReducers,
  Reducer,
  createStore,
  applyMiddleware,
  Store,
  Middleware
} from 'redux';

import { ApplicationState } from './types';
import WizardReducer from './wizard/reducer';
import ApplicationFormReducer from './application/reducer';
import UploaderReducer from './upload/reducer';

export const rootReducer: Reducer<ApplicationState> = combineReducers<
  ApplicationState
>({
  wizard: WizardReducer,
  applicationForm: ApplicationFormReducer,
  form: ReduxFormReducer,
  uploader: UploaderReducer
});

const middlewares: Middleware[] = [thunk, asyncValidationMiddlware];

if (process.env.NODE_ENV === `development`) {
  middlewares.push(logger);
}

export default function configureStore(
  preloadedState?: ApplicationState
): Store<ApplicationState> {
  return createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(...middlewares)
  );
}
